import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WhatsappPdfComponent } from './whatsapp-pdf.component';

const routes: Routes = [{ path: '', component: WhatsappPdfComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WhatsappPdfRoutingModule { }
